<app-main-nav>
  <router-outlet></router-outlet>
</app-main-nav>

